import BaseCommand from "@/models/api/commands/BaseCommand";
import { BookingItemToImport } from "@/models/api/orders/BookingItemToImport";

export interface ImportBookingItemsCommandParams {
  MarkedByUser: boolean;
  Guids: Array<string>;
  CalculateBookingItems: Array<BookingItemToImport>;
}

export class ImportBookingItemsCommand extends BaseCommand {
  CommandName = "ImportBookingItems";
  Command: ImportBookingItemsCommandParams;
  constructor(sessionId: string, operationId: string, params: ImportBookingItemsCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
